import script from "./AltarMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AltarMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./AltarMultiSelect.vue?vue&type=style&index=0&id=4cf0468a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf0468a"]])

export default __exports__